import { CheckCircleIcon, LinkIcon } from '@heroicons/react/24/solid';
import { FC, useState } from 'react';
import Clipboard from 'react-clipboard.js';

export interface ShareLinkProps {
  url: string;
}

const ShareLink: FC<ShareLinkProps> = ({ url }) => {
  const [isCopied, setIsCopied] = useState(false);

  function handleClick() {
    setIsCopied(true);
  }

  return (
    <Clipboard data-clipboard-text={url}>
      <span
        onClick={handleClick}
        className="inline-flex h-12 w-12 items-center justify-center border border-neutral-200 text-neutral-600 hover:z-10 hover:border-neutral-600 hover:bg-neutral-600 hover:text-white dark:border-neutral-400 dark:text-neutral-400 dark:hover:bg-neutral-800 dark:hover:text-white"
      >
        {isCopied ? (
          <CheckCircleIcon className="h-4 w-4" />
        ) : (
          <LinkIcon className="h-4 w-4" />
        )}
      </span>
    </Clipboard>
  );
};

export default ShareLink;
